// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__0r3Fh","mobile_header":"Header_mobile_header__DXSo0","wish_bage":"Header_wish_bage___4_A0"};